import { Icon } from '@toggle/design-system';
import styled from 'styled-components';

export const RemoveText = styled.span`
  color: var(--text-critical);
  display: flex;
`;

export const TrashIcon = styled(Icon).attrs({ size: 16 })`
  margin-right: 8px;
  fill: var(--icon-critical);
`;
